module.exports = __webpack_public_path__ + "static/img/materialsInfo10.cee68bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo10.png
// module id = 6npq
// module chunks = 2